/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Base_HelpInputs */

const en_directory_api_reference_base_help = /** @type {(inputs: Directory_Api_Reference_Base_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Four addresses power the whole channel.`)
};

const zh_directory_api_reference_base_help = /** @type {(inputs: Directory_Api_Reference_Base_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个通路只靠这四个地址。`)
};

/**
* | output |
* | --- |
* | "Four addresses power the whole channel." |
*
* @param {Directory_Api_Reference_Base_HelpInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_base_help = /** @type {((inputs?: Directory_Api_Reference_Base_HelpInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Base_HelpInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_base_help(inputs)
	return zh_directory_api_reference_base_help(inputs)
});
export { directory_api_reference_base_help as "directory.api_reference.base_help" }